import { useEffect, useState } from "react";

export default function CountdownTimer({ endsAt, status, onExpire, size = "md" }) {
  const [secondsLeft, setSecondsLeft] = useState(() => calc(endsAt));

  useEffect(() => {
    setSecondsLeft(calc(endsAt));
  }, [endsAt]);

  useEffect(() => {
    if (status !== "live") return;
    const t = setInterval(() => {
      const s = calc(endsAt);
      setSecondsLeft(s);
      if (s <= 0 && onExpire) onExpire();
    }, 250);
    return () => clearInterval(t);
  }, [endsAt, status, onExpire]);

  if (status !== "live") {
    return (
      <div className={`font-mono-nums font-bold ${size === "lg" ? "text-4xl" : "text-xl"} text-zinc-500`}>
        CLOSED
      </div>
    );
  }

  const s = Math.max(0, secondsLeft);
  const cls = s <= 5 ? "timer-urgent" : "timer-live";
  const label = s < 60 ? `${s.toFixed(0)}s` : `${Math.floor(s / 60)}m ${Math.floor(s % 60)}s`;

  return (
    <div
      className={`font-mono-nums font-bold ${cls} ${size === "lg" ? "text-5xl" : "text-2xl"}`}
      data-testid="countdown-timer"
    >
      {label}
    </div>
  );
}

function calc(endsAt) {
  if (!endsAt) return 0;
  return (new Date(endsAt).getTime() - Date.now()) / 1000;
}
